import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'http://apiv4.godd.b1.finki.ukim.mk//'
});

export default axiosInstance;
